import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
import { allowedLinks } from "@nxplatform/platform-settings/locale-setup.routes";
import { isDisabledPromotions } from "@nxplatform/platform-settings/locale-setup.selectors";
const MENU_CMS_FEATURE_KEY = "menuCms";
var MenuCmsRouteType = /* @__PURE__ */ ((MenuCmsRouteType2) => {
  MenuCmsRouteType2[MenuCmsRouteType2["mainMenu"] = 1] = "mainMenu";
  MenuCmsRouteType2[MenuCmsRouteType2["cabinet"] = 2] = "cabinet";
  return MenuCmsRouteType2;
})(MenuCmsRouteType || {});
var MenuCmsPosition = /* @__PURE__ */ ((MenuCmsPosition2) => {
  MenuCmsPosition2[MenuCmsPosition2["top"] = 1] = "top";
  MenuCmsPosition2[MenuCmsPosition2["bottom"] = 2] = "bottom";
  return MenuCmsPosition2;
})(MenuCmsPosition || {});
var MenuCmsLabel = /* @__PURE__ */ ((MenuCmsLabel2) => {
  MenuCmsLabel2[MenuCmsLabel2["new"] = 1] = "new";
  return MenuCmsLabel2;
})(MenuCmsLabel || {});
const MenuInitialState = [];
const initialMenuCmsState = {
  mainMenu: MenuInitialState,
  loaded: false,
  error: null,
  topMenuItemActive: null
};
const menuCmsSlice = createSlice({
  name: MENU_CMS_FEATURE_KEY,
  initialState: initialMenuCmsState,
  reducers: {
    getMainMenuCmsStart: (state) => {
      state.loaded = false;
    },
    getMainMenuCmsSuccess: (state, action) => {
      state.loaded = true;
      state.mainMenu = action.payload;
    },
    getMainMenuCmsFailure: (state, action) => {
      state.loaded = true;
      state.error = action.payload;
    },
    setTopMenuItemActive: (state, action) => {
      state.topMenuItemActive = action.payload;
    }
  }
});
const menuCmsReducer = menuCmsSlice.reducer;
const {
  getMainMenuCmsStart,
  getMainMenuCmsSuccess,
  getMainMenuCmsFailure,
  setTopMenuItemActive
} = menuCmsSlice.actions;
const getMenuCmsState = (rootState) => rootState[MENU_CMS_FEATURE_KEY];
const selectFilteredAndSortedMainMenuCms = createSelector(
  [getMenuCmsState, isDisabledPromotions],
  (s, promotionsDisabled) => {
    var _a, _b, _c;
    const mainMenu = (s == null ? void 0 : s.mainMenu) ? [...s.mainMenu] : null;
    return (_c = (_b = (_a = mainMenu == null ? void 0 : mainMenu.filter((item) => item.title)) == null ? void 0 : _a.filter((item) => item.active)) == null ? void 0 : _b.filter((item) => !(promotionsDisabled && allowedLinks.promotions.includes(item.path)))) == null ? void 0 : _c.sort((a, b) => a.displayOrder - b.displayOrder);
  }
);
const selectMainMenuCmsHeader = createSelector(
  selectFilteredAndSortedMainMenuCms,
  (filteredMainMenu) => {
    return filteredMainMenu == null ? void 0 : filteredMainMenu.filter((item) => item.menuPosition === null);
  }
);
const selectIsMainMenuCmsHeader = createSelector(
  selectMainMenuCmsHeader,
  (filteredMainMenu) => {
    return !!(filteredMainMenu == null ? void 0 : filteredMainMenu.length);
  }
);
const selectMainMenuCmsTop = createSelector(
  selectFilteredAndSortedMainMenuCms,
  (filteredMainMenu) => {
    return filteredMainMenu == null ? void 0 : filteredMainMenu.filter((item) => item.menuPosition === 1);
  }
);
const selectIsMainMenuCmsTop = createSelector(
  selectMainMenuCmsTop,
  (filteredMainMenu) => {
    return !!(filteredMainMenu == null ? void 0 : filteredMainMenu.length);
  }
);
const selectMainMenuCmsBottom = createSelector(
  selectFilteredAndSortedMainMenuCms,
  (filteredMainMenu) => {
    return filteredMainMenu == null ? void 0 : filteredMainMenu.filter((item) => item.menuPosition === 2);
  }
);
const selectIsMainMenuCmsBottom = createSelector(
  selectMainMenuCmsBottom,
  (filteredMainMenu) => {
    return !!(filteredMainMenu == null ? void 0 : filteredMainMenu.length);
  }
);
const selectMainMenuCmsLoaded = createSelector(
  getMenuCmsState,
  (s) => s.loaded
);
const selectMainMenuCmsError = createSelector(
  getMenuCmsState,
  (s) => s.error
);
const selectTopMenuItemActive = createSelector(
  getMenuCmsState,
  (s) => s.topMenuItemActive
);
const mainMenuCmsEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getMainMenuCmsStart.type),
  switchMap((action) => Api.cms.getMainMenu(action).pipe(
    map((results) => getMainMenuCmsSuccess(results)),
    catchError((err) => of(getMainMenuCmsFailure(err)))
  ))
);
const fetchMainMenuCms = (params) => ({
  type: getMainMenuCmsStart.type,
  payload: params
});
export {
  MENU_CMS_FEATURE_KEY,
  MenuCmsLabel,
  MenuCmsPosition,
  MenuCmsRouteType,
  MenuInitialState,
  fetchMainMenuCms,
  getMainMenuCmsFailure,
  getMainMenuCmsStart,
  getMainMenuCmsSuccess,
  getMenuCmsState,
  initialMenuCmsState,
  mainMenuCmsEpic,
  menuCmsReducer,
  menuCmsSlice,
  selectFilteredAndSortedMainMenuCms,
  selectIsMainMenuCmsBottom,
  selectIsMainMenuCmsHeader,
  selectIsMainMenuCmsTop,
  selectMainMenuCmsBottom,
  selectMainMenuCmsError,
  selectMainMenuCmsHeader,
  selectMainMenuCmsLoaded,
  selectMainMenuCmsTop,
  selectTopMenuItemActive,
  setTopMenuItemActive
};
